export default `
  mutation updateOrgMember($id: String!, $orgId: String!, $role: OrgMemberRole!) {
    updateOrgMember(id: $id, orgId: $orgId, role: $role) {
      id
      orgId
      userId
      role
      updatedAt
    }
  }
`
